import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmt } from "@/lib/api";
import { Avatar } from "@/components/Avatar";
import { Chip, Empty } from "@/components/ui-bits";

const STATUS = { new: ["warn", "new"], converted: ["ok", "client"], dismissed: ["gray", "dismissed"] };

export const ReferralLeads = ({ onConverted }) => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const load = useCallback(() => api.get("/referrals").then((r) => setD(r.data)), []);
  useEffect(() => { load(); }, [load]);
  if (!d) return null;
  const leads = showAll ? d.leads : d.leads.filter((l) => l.status === "new");
  const fresh = d.leads.filter((l) => l.status === "new").length;
  const convert = async (l) => {
    if (!window.confirm(`Add ${l.name} as a client? They get a login (default password password123)${d.settings.rewardSessions > 0 ? ` and ${l.referrerName} earns ${d.settings.rewardSessions} free session${d.settings.rewardSessions !== 1 ? "s" : ""}` : ""}.`)) return;
    setBusy(l.id);
    try { const r = await api.post(`/referrals/${l.id}/convert`, {}); toast.success(`${l.name} added as a client${d.settings.rewardSessions > 0 ? ` — ${l.referrerName} rewarded` : ""}`); load(); onConverted?.(r.data.clientId); }
    catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(null); }
  };
  const dismiss = async (l) => { setBusy(l.id); try { await api.post(`/referrals/${l.id}/dismiss`); load(); } catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(null); } };
  return (
    <div className="panel fade" id="referrals" data-testid="referral-leads-panel">
      <div className="ph">
        <h3>Referrals · {fresh} new lead{fresh !== 1 ? "s" : ""} from your clients' share links</h3>
        <button className="btn g sm" onClick={() => setShowAll(!showAll)} data-testid="referrals-toggle-all">{showAll ? "New only" : `All (${d.leads.length})`}</button>
      </div>
      {leads.length === 0 && <Empty>{showAll ? "No referrals yet — every client has a share link on their portal Home." : "No new leads. Clients share their link; friends land here."}</Empty>}
      {leads.map((l) => (
        <div className="sess" key={l.id} data-testid={`referral-lead-${l.id}`}>
          <Avatar client={{ id: l.referrerClientId, photoKey: l.referrerPhotoKey, name: l.referrerName }} size={34} radius={9} />
          <div className="sb">
            <div className="st">{l.name} <span className="ss">· via {l.referrerName}</span></div>
            <div className="ss">{l.email}{l.phone ? ` · ${l.phone}` : ""} · {fmt(l.createdAt, { day: "numeric", month: "short" })}{l.note ? ` · “${l.note}”` : ""}</div>
          </div>
          <Chip cls={STATUS[l.status]?.[0]} label={STATUS[l.status]?.[1] || l.status} />
          {l.status === "new" && <button className="btn sm" disabled={busy === l.id} onClick={() => convert(l)} data-testid={`referral-convert-${l.id}`}>{busy === l.id ? "Adding…" : "Add as client"}</button>}
          {l.status === "new" && <button className="btn sm g" disabled={busy === l.id} onClick={() => dismiss(l)} data-testid={`referral-dismiss-${l.id}`}>Dismiss</button>}
        </div>
      ))}
    </div>
  );
};
